import { PaymentMethodType } from '@nemuru-eng/js-api-client';

import { AbstractLoanPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/AbstractLoanPaymentMethod';
import { LoanConditions } from '@/components/modules/Application/components/PaymentMethod/_shared/types/LoanConditions';
import { PaymentMethodRequestType } from '@/components/modules/Application/components/PaymentMethod/_shared/types/PaymentMethodRequestType';
import { BnplConditionsGroup } from '@/components/modules/Application/components/PaymentMethod/Bnpl/entities/ConditionsGroup/BnplConditionsGroup';

type BnplPaymentMethodRequest = PaymentMethodRequestType<
  PaymentMethodType.BNPL_INSTALMENTS | PaymentMethodType.BNPL_SPLIT_PAY
>;

export class BnplPaymentMethod extends AbstractLoanPaymentMethod {
  protected ALLOWED_PAYMENT_METHOD_TYPES = [PaymentMethodType.BNPL_INSTALMENTS, PaymentMethodType.BNPL_SPLIT_PAY];

  public areOptionsConfigurable(): boolean {
    return false;
  }

  protected setAvailableFilters(): void {
    return;
  }

  protected getAvailableConditions(allConditions: LoanConditions[]): LoanConditions[] {
    return allConditions;
  }

  protected getSelectedTermCandidate(availableTerms: number[]): number {
    return availableTerms[availableTerms.length - 1];
  }

  protected getConditionsGroups(availableConditions: LoanConditions[], term: number): BnplConditionsGroup[] {
    const filteredConditions = availableConditions.filter((condition) => condition.term === term);
    return [new BnplConditionsGroup(filteredConditions)];
  }

  protected getSelectedConditionsGroupCandidate(conditionsGroups: BnplConditionsGroup[]): BnplConditionsGroup {
    // FIXME: refactor
    return conditionsGroups[0];
  }

  public get proposedTerms(): number[] {
    return this.availableTerms;
  }

  public toDto(): BnplPaymentMethodRequest {
    if (!this.selectedTerm) {
      throw new Error('Term is not selected');
    }

    return {
      type: this.paymentMethodType as BnplPaymentMethodRequest['type'],
      options: {
        period: this.selectedTerm,
      },
    };
  }
}
